import SystemHelper from 'features/System/systemHelper';
import KTFormInput, {
  KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import AppColors from 'general/constants/AppColors';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useState } from 'react';

DialogChangePasswordView.propTypes = {
  onCancel: PropTypes.func,
  onDone: PropTypes.func,
};

function DialogChangePasswordView({ onCancel, onDone }) {
  // MARK: ---- PROPERTIES ----
  const [loading, setLoading] = useState(false);
  const [readyToValidate, setReadyToValidate] = useState(false);
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  // MARK: ---- FUNCTIONS ----
  const handleSubmit = async () => {
    setReadyToValidate(true);

    if (
      !Utils.isValid(oldPassword) ||
      !Utils.isValid(newPassword) ||
      !Utils.isValid(confirmPassword)
    ) {
      ToastHelper.showError('Vui lòng nhập đầy đủ thông tin');
      return;
    }
    if (newPassword !== confirmPassword) {
      ToastHelper.showError('Mật khẩu xác nhận không khớp');
      return;
    }
    if (oldPassword === newPassword) {
      ToastHelper.showError('Mật khẩu mới không được trùng với mật khẩu cũ');
      return;
    }
    if (newPassword.length < 6) {
      ToastHelper.showError('Mật khẩu phải có ít nhất 6 ký tự');
      return;
    }

    const params = {
      oldPassword: oldPassword,
      newPassword: newPassword,
    };
    setLoading(true);
    const res = await SystemHelper.API.Account.requestChangePassword(params);
    if (_.isBoolean(res) && res) {
      ToastHelper.showSuccess('Đổi mật khẩu thành công');
      onDone();
    } else if (_.isString(res)) {
      ToastHelper.showError(res);
    }
    setLoading(false);
  };

  return (
    <div>
      <div className="row m-0 p-0 px-2 mt-4">
        {/* mat khau cu */}
        <div className="col-12 mb-4 px-2">
          <div>
            {UIHelper.buildFormLabel('Mật khẩu cũ', true)}
            <KTFormInput
              type={KTFormInputType.customPassword}
              placeholder="Nhập mật khẩu cũ"
              name="oldPassword"
              value={oldPassword}
              onChange={(value) => {
                setOldPassword(value);
              }}
              enableCheckValid={readyToValidate}
              isValid={Utils.isValid(oldPassword)}
              isTouched={true}
              feedbackText={!Utils.isValid(oldPassword) ? 'Bạn chưa nhập mật khẩu cũ' : ''}
            />
          </div>
        </div>
        {/* mat khau moi */}
        <div className="col-12 mb-4 px-2">
          <div>
            {UIHelper.buildFormLabel('Mật khẩu mới', true)}
            <KTFormInput
              type={KTFormInputType.customPassword}
              placeholder="Nhập mật khẩu mới"
              name="newPassword"
              value={newPassword}
              onChange={(value) => {
                setNewPassword(value);
              }}
              enableCheckValid={readyToValidate}
              isValid={Utils.isValid(newPassword)}
              isTouched={true}
              feedbackText={!Utils.isValid(newPassword) ? 'Bạn chưa nhập mật khẩu mới' : ''}
            />
          </div>
        </div>
        {/* nhap lai mat khau moi */}
        <div className="col-12 mb-4 px-2">
          <div>
            {UIHelper.buildFormLabel('Nhập lại mật khẩu mới', true)}
            <KTFormInput
              type={KTFormInputType.customPassword}
              placeholder="Nhập mật khẩu mới"
              name="confirmPassword"
              value={confirmPassword}
              onChange={(value) => {
                setConfirmPassword(value);
              }}
              enableCheckValid={readyToValidate}
              isValid={Utils.isValid(confirmPassword) && _.isMatch(newPassword, confirmPassword)}
              isTouched={true}
              feedbackText={
                !Utils.isValid(confirmPassword)
                  ? 'Bạn chưa nhập lại mật khẩu mới'
                  : !_.isMatch(newPassword, confirmPassword)
                    ? 'Mật khẩu không khớp'
                    : ''
              }
            />
          </div>
        </div>
      </div>

      <div
        className="d-flex align-items-center justify-content-center gap-3 px-4 py-3"
        style={{
          borderTop: `1px solid ${AppColors.gray[200]}`,
        }}
      >
        {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null, true)}
        {UIHelper.buildGreenButton('Đổi mật khẩu', handleSubmit, null, true, loading)}
      </div>
    </div>
  );
}

export default DialogChangePasswordView;
